import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Card, FlexView, Button } from 'components/common'
import { Input } from 'components/form'
import styled from 'styled-components'
import { TransportContext } from 'stores/ManagementTransportStore'
import { IoTrashSharp } from 'react-icons/io5'


const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  width: 100%
`

const Title = styled.h1`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
`
const AttachEvidenceModal = ({ isOpen, onOutsideClick, title }) => {
	const { t } = useTranslation()
	const [file, setFile] = useState([])
	const [disable, setDisable] = useState(true)
	const [fileList, setFileList] = useState([])
	const { sendAttachment } = useContext(TransportContext)

	useEffect(() => {
		setFile([])
		setDisable(true)
	}, [onOutsideClick])

	const readFile = (evt) => {
		setFile(evt)
		setDisable(false)
	}

	console.log(fileList)
	return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
		<Card width="50%">
			<Title>{t(`transport.${title}`)}</Title>
			<FlexView width="100%" flexDirection="row" alignItems="center" justifyContent="space-between" style={{ columnGap: '5%' }}>
				<Input width="100%" type='file' onChange={({ target: { files } }) => { readFile(files[0]) }} accept="image/*, application/pdf" />
				<Button backgroundColor='primary' color='white' onClick={() => setFileList([...fileList, file])}>{t(`transport.add`)}</Button>
			</FlexView>
			<Grid>
				{
					fileList.map((item, index) => (
						<Card key={index} flexDirection="row" alignItems="center" justifyContent="space-between">
							{item?.name}
							<IoTrashSharp
								onClick={() => {
									setFileList(fileList.filter((item, i) => { return i !== index }))
								}}
								size={25}
								style={{ color: '#FB7171' }}
								cursor={'pointer'}
								title={t('transport.delete')} />
						</Card>
					))
				}
			</Grid>
			<FlexView width="100%" flexDirection="row" alignItems="center" justifyContent="flex-end" style={{ columnGap: '5%' }}>
				<Button onClick={() => { onOutsideClick() }}>
					{t('transport.cancel')}
				</Button>
				<Button backgroundColor='primary' color='white' disabled={disable} onClick={async () => { await sendAttachment(fileList, 'Evidência de transporte'); onOutsideClick() }}>
					{t(`transport.save`)}
				</Button>
			</FlexView>
		</Card>
	</Modal>
}

export default AttachEvidenceModal
